module.exports = __webpack_public_path__ + "static/img/home_type_icon_zzcx.0d50049d.webp";